import { useRoutes } from 'react-router';
import { MantineProvider, Global } from '@mantine/core';

import { NotificationsProvider } from '@mantine/notifications';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Provider } from 'react-redux';
import { useLocalStorage } from '@mantine/hooks';
import routes from './router/routes';
import { store } from './store';
import './i18n';
import './App.css';
import LandingLayout from './components/LandingLayout';
import AppContext from './components/Context/index';

import black from './fonts/SukarBlack.woff2';
import bold from './fonts/SukarBold.woff2';

const App = () => {
  const { i18n } = useTranslation();

  const routeElement = useRoutes(routes);
  const [appState, setAppState] = useLocalStorage({ key: 'language', defaultValue: 'en' });

  useEffect(() => {
    const languageValue = appState?.language;
    i18n.changeLanguage(languageValue);
    document.dir = appState?.language === 'ar' ? 'rtl' : 'ltr';
  }, [appState?.language, i18n]);

  const memoizedValue = useMemo(() => ({ appState, setAppState }), [appState, setAppState]);

  return (
    <AppContext.Provider value={memoizedValue}>
      <Global
        styles={[
          {
            '@font-face': {
              fontFamily: 'Sukar',
              src: `url('${bold}') format("woff2")`,
              fontWeight: 700,
              fontStyle: 'normal',
            },
          },
          {
            '@font-face': {
              fontFamily: 'Sukar',
              src: `url('${black}') format("woff2")`,
              fontWeight: 900,
              fontStyle: 'normal',
            },
          },
        ]}
      />
      <MantineProvider
        className="example"
        withGlobalStyles
        withNormalizeCSS
        emotionOptions={appState?.language === 'ar' ? { key: 'mantine-rtl' } : { key: 'mantine' }}
        theme={{
          colorScheme: 'light',
          breakpoints: {
            xs: 500,
            sm: 800,
            md: 1000,
            lg: 1200,
            xl: 1400,
          },
          // dir: 'rtl',/
          dir: appState?.language === 'ar' ? 'rtl' : 'ltr',
          colors: {
            brand: [
              '#f2f2f2',
              '#e6e6e6',
              '#bfbfbf',
              '#999999',
              '#4d4d4d',
              '#000000',
              '#000000',
              '#000000',
              '#000000',
              '#000000',
            ],
            'deep-blue': ['#E9EDFC', '#C1CCF6', '#99ABF0' /* ... */],
          },
          primaryColor: 'brand',
          headings: {
            fontFamily: 'Sukar',
          },
          lineHeight: '1.6  ',

          fontFamily: 'Sukar',
        }}
      >
        <NotificationsProvider position="top-right">
          <LandingLayout>
            <Provider store={store}>{routeElement}</Provider>
          </LandingLayout>
        </NotificationsProvider>
      </MantineProvider>
    </AppContext.Provider>
  );
};

export default App;
